import { useEffect, useState } from 'react';
import { TelegramThemeParams } from '../types/telegram';
import { applyTelegramTokens } from '../utils/telegramTokens';

/**
 * Hook to manage Telegram Mini App theme.
 * Maps Telegram theme parameters onto the app's role tokens (so every
 * primitive follows Telegram's colours, spec 4.9) and tracks the current
 * colour scheme, both on mount and on Telegram's `themeChanged` event.
 */
export const useTelegramTheme = () => {
    const [themeParams, setThemeParams] = useState<TelegramThemeParams | null>(null);
    const [colorScheme, setColorScheme] = useState<'light' | 'dark'>(
        () => window.Telegram?.WebApp?.colorScheme || 'light'
    );

    useEffect(() => {
        const tg = window.Telegram?.WebApp;
        if (!tg) return;

        const applyTheme = () => {
            const params = tg.themeParams;
            setThemeParams(params);
            applyTelegramTokens(params);
            setColorScheme(tg.colorScheme || 'light');
        };

        // Initial application
        applyTheme();

        // Listen for changes
        tg.onEvent('themeChanged', applyTheme);
        return () => {
            tg.offEvent('themeChanged', applyTheme);
        };
    }, []);

    return {
        themeParams,
        colorScheme,
    };
};
